import { Content, DefaultPage, Footer } from "@shared/layout/DefaultPage";
import { Heading } from "@ui/Heading";
import BottomArrow from "@assets/icons/FatBottomArrow.svg";
import { Centered } from "@shared/layout/Centered";
import Logo from "@assets/icons/tisit_logo_full.svg";
import { CSSProperties, useState } from "react";
import { PhoneButton } from "@pages/auth/pages/ui/phoneButton";
import { ThirdPartyAuthList } from "./ui/ThirdPartyAuth/list";
import { SubscribeToNotifications } from "./ui/subscribeToNotifications";
import { Link } from "react-router-dom";
import { ROUTES } from "@shared/constants/routes";
import {
  createKeycloakLoginUrl,
  isNativeAuthPlatform,
} from "@shared/lib/authRedirect";
import { Browser } from "@capacitor/browser";

export default function Hello() {
  const [isNotificationSelected, setIsNotificationSelected] =
    useState<boolean>(false);
  const [isLoginLoading, setIsLoginLoading] = useState<boolean>(false);

  const handleLogin = async () => {
    if (isLoginLoading) return;

    try {
      setIsLoginLoading(true);
      const loginUrl = await createKeycloakLoginUrl(ROUTES.auth.enterBaseInfo);

      if (isNativeAuthPlatform()) {
        await Browser.open({ url: loginUrl });
        return;
      }

      window.location.assign(loginUrl);
    } finally {
      setIsLoginLoading(false);
    }
  };

  return (
    <DefaultPage style={{ background: "white" }}>
      <Content style={{ "--background": "#fff" } as CSSProperties}>
        <div className={"flex min-h-full flex-col"}>
          <Centered>
            <Heading weight={700} size={18}>
              Войти
            </Heading>
          </Centered>
          <Centered className={"flex-col gap-y-5"}>
            <img src={BottomArrow} alt="" className={"mt-5"} />
            <img
              src={Logo}
              alt="TISIT"
              className={"h-[36px] w-[74px] object-contain"}
            />
            <h5
              className={"text-[14px] text-[#7a7a7c] text-center font-medium"}
            >
              Ваш персональный,
              <br />
              карманный тренер
            </h5>
          </Centered>
          <PhoneButton
            className={"mt-10"}
            disabled={isLoginLoading}
            onClick={() => void handleLogin()}
          />
          <div
            className={"text-center text-[11px] mt-auto text-[#7A7A7C] mb-10"}
          >
            Авторизуясь, вы принимаете положения документа{" "}
            <Link
              to={ROUTES.overall.userAgreement}
              className={"text-[#0B73FE]"}
            >
              Условия использования
            </Link>{" "}
            и подтверждаете, что прочитали документ{" "}
            <Link
              to={ROUTES.overall.privacyPolicy}
              className={"text-[#0B73FE]"}
            >
              Политика конфиденциальности
            </Link>
            , где описано, как мы собираем, используем и передаем ваши данные
          </div>
        </div>
      </Content>
    </DefaultPage>
  );
}
